'use strict';

/**
 * Resource Service (wdResourceService.js).
 * Resource Service.
 *
 *
 * @version
 * 2.0.0 LIBENV-99 Implement bcxOauth2HttpService for native HTTP requests
 * 1.31.0 LIBENV-97 Revert breaking changes in wdEnvironmentService
 * 1.30.0 LIBENV-95 Create new Oauth2HttpService to handle native http responses
 * 1.1.0 LIBENV-4 Get inventory type URL from tracker-api method name conflict
 * 1.0.0 LIBENV-1 Initialize environment library
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright 2018-2021 Build Centrix
 */
angular.module('wd.service.resource', [
    'bcx.service.oauth2http',
    'wd.helper.constants',
    'wd.helper.configuration',
    'wd.service.oauth2http',
    'wd.helper.permissions',
    'wd.helper.resources'])
    .factory('wdResourceService',
        ['$q', 'bcxOauth2HttpService', 'wdConfigurationHelper',
            'wdConstantHelper', 'wdOauth2HttpService', 'wdPermissionHelper', 'wdResourceHelper',
            function($q, bcxOauth2HttpService, wdConfigurationHelper,
                     wdConstantHelper, wdOauth2HttpService, wdPermissionHelper, wdResourceHelper) {

            /**
             * Service: Resources
             *
             * @since 1.0.0
             * @type {Object}
             */
            var service = {};

            /**
             * Initialize Resources
             *
             * @since 1.0.0
             * @returns {Q.Promise}
             */
            service.initialize = function () {

                var deferred = $q.defer();

                // If we ever want to pull permissions
                // from an API call, we do that here
                wdConfigurationHelper.getBaseUrl() ? wdResourceHelper.setBaseUrl(wdConfigurationHelper.getBaseUrl()) : false;
                wdConfigurationHelper.getBaseApiPath() ? wdResourceHelper.setBaseApiUrl(wdConfigurationHelper.getBaseApiPath()) : false;
                bcxOauth2HttpService.getDeploymentToken() ? wdResourceHelper.setDeploymentToken(bcxOauth2HttpService.getDeploymentToken()) : false;
                wdOauth2HttpService.getDeploymentToken() ? wdResourceHelper.setDeploymentToken(wdOauth2HttpService.getDeploymentToken()) : false;
                wdResourceHelper.setConstants(wdConstantHelper);
                wdResourceHelper.setPermissions(wdPermissionHelper);
                service.setApiUrls();

                deferred.resolve(true);

                return deferred.promise;

            };

            /**
             * Set API URLs
             * Used if API URLs are required in addition to the baseApiUrl
             *
             * @since 1.1.0
             */
            service.setApiUrls = function() {
                var apiUrls = [];
                var trackerApiUrl = wdConfigurationHelper.getTrackerApiPath();

                if (trackerApiUrl) {
                    var trackerApi = {
                        id: 'tracker',
                        url: trackerApiUrl
                    };
                    apiUrls.push(trackerApi);
                }

                if (apiUrls.length > 0) {
                    wdResourceHelper.setApiUrls(apiUrls);
                }

            };

            return service;

        }]);

// EOF